import { ajax } from '@/api/ajax';

export interface FullTextSearchReq {
  /**
   * 搜索关键词
   */
  keyword?: string;
  currentPage: number;
  size: number;
  bookmapCodeList?: string[];
  lang?: string;
  modelCode?: string;
}

export interface FullTextSearchResponse {
  /**
   * 总条数
   */
  total: number;
  /**
   * 当前页面条数
   */
  size: number;
  /**
   * 分页对象
   */
  records: FullTextSearchRecord[];
}

export interface FullTextSearchRecord {
  /**
   * 手册编码
   */
  bookmapCode: string;
  /**
   * 手册名称
   */
  bookmapName: string;
  /**
   * 手册类型，字典：BOOKMAP_TYPE
   * UM-用户手册，RM-维修手册，CRM-车身维修手册，DT-电路图手册，ST-维修工具，RE-救援卡
   */
  bookmapType: string;
  /**
   * 手册类型名称
   */
  bookmapTypeName: string;
  /**
   * 版本号
   */
  bookmapVersion: string;
  /**
   * 语言，字典：BASE_LANGUAGE
   */
  lang: string;
  /**
   * 语言说明
   */
  langName: string;
  /**
   * 适用车系，EPCM的车系数据
   */
  seriesCode: string;
  /**
   * 文章编码
   */
  topicCode: string;
  uniqueCode: string;
  /**
   * 文章标题
   */
  topicName: string;
  topicVersion: string;
  /**
   * 文章结构标题
   */
  structureList: string;
  /**
   * 内容
   */
  content: string;
  path: string;
}

export function fullTextSearchUsingPost(data: FullTextSearchReq) {
  return ajax<FullTextSearchResponse>({
    url: '/api/tis/web/bookmap/queryByKeyword',
    method: 'post',
    data: data
  });
}
